import React from 'react';
import {Header,Item, Label,  Breadcrumb, Embed, Transition, Icon, Segment,Container, Loader,Image, Dropdown, Divider, Form, Dimmer, TextArea,   Button, Grid,Input, Radio, Message} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Content from '../NetflixSlider/ContentHeader';
import Slider from '../NetflixSlider'; 
import Modulos from './Modulos';
import SlideShow from 'react-slideshow-ui';
import Crossword from '@jaredreisinger/react-crossword';
import Quiz from 'react-quiz-component';
//import Player from 'react-media-viewer';
import moment from 'moment';
import { Document, Page } from 'react-pdf';
//import ReactPlayer from 'react-player/lazy'
import ReactPlayerSin from 'react-player/lazy'
import $ from 'jquery';

$(document).ready(function(){

        $('#videoElementID').bind('contextmenu',function() { return false; });
    });


const CursoView=({ id, color, idTipoContenido, referencia, urlContenido , onSeek,tituloContenido,  curso, onVisible, regresar, visible, onAcordionModulo, modulos,cursosActuales,cursosPrevios,  form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, quiz, setQuizResult, renderCustomResultPage, showModalComents,fechaActual, handleClick, videoProgreso, onDuration,videoTerminado, fechaComentario, errorExamen, saveExamen, dataCrucigrama, dataArray, goBack })=>{

 
    
    let data={
  across: {
    1: {
      clue: 'one plus one',
      answer: 'TWO',
      row: 0,
      col: 0,
    },
  },
  down: {
    2: {
      clue: 'three minus two',
      answer: 'ONE',
      row: 0,
      col: 2,
    },
  },
};
    let currentSlide={
    id: 5,
        url:"/curso/",   
    image: '/images/capsula.jpeg',
    imageBg: '/images/capsula.jpeg',
    title: 'Cápsulas de Control de Calidad'
      , desc:"Mi descripcnp ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque"+
          "et euismod ligula. Morbi mattis pretium eros, ut mollis leo tempus"+
          "eget. Sed in dui ac ipsum feugiat ultricies. Phasellus vestibulum enim"+
          "quis quam congue, non fringilla orci placerat. Praesent sollicitudin"

  };
    
    
  
	return (
        <div>
            <Dimmer.Dimmable   dimmed={ajaxCallInProgress>0?true:false}>
        
      
            <Grid>
                 <Grid.Row only='computer tablet'>
                    <Grid.Column textAlign="center" width={16}>

                        {curso.imageCr!=null?
                            <Image src={curso.imageCr} fluid  />
                        :
                            <Image size="large"  src={curso.image} wrapped  />
                        }
                    </Grid.Column>
                </Grid.Row>  
                <Grid.Row only='mobile' >

                    <Grid.Column textAlign="center">

                        <Image src={curso.image} fluid />
                    </Grid.Column>    

                </Grid.Row>    


            </Grid>
        
        
        
           
       
        
            <Segment basic>

                <Button color='instagram' fluid size='large'  onClick={goBack}
										>{strings?strings["regresar"]:""}</Button>

        
        
            {visible?
                <Modulos 
                    allowAccess={curso.allowAccess}    
                    titulo={curso.title}
                    modulos={curso.modulos} 
                    onVisible={onVisible}
                    onAcordionModulo={onAcordionModulo}
                    showModalComents={showModalComents}
                    handleClick={handleClick}
                    fechaActual={fechaActual}
                    fechaComentario={fechaComentario}/>
            :
                ""
            }
                 

            <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
                <Loader size='big'  content={strings?strings["Procesando"]:""}/>
            </Dimmer>

        
        
        
        
            {idTipoContenido==26 &&visible==false ?
                <div>
                    <Header as='h3'>{tituloContenido}</Header>
                    <Button onClick={regresar} color='instagram' fluid size='large'>
                        Regresar
                    </Button> 

                    <Embed
                        icon='right circle arrow'
                        placeholder='/images/image-16by9.png'
                        url={urlContenido}
                        active={true}
                    />
                    <Grid>        
                    <Grid.Row only='tablet'>
                             <Grid.Column>
                                <Segment basic>
                                    Si no puedes ver el pdf da clic en Link
                                    <Icon size="large" color="green" link onClick={()=>handleClick(urlContenido)} name="linkify" />
                                </Segment>
                            </Grid.Column>
                        </Grid.Row>    
                    </Grid>
                </div>
            :
                ""
            }
        
        
            {idTipoContenido==27 &&visible==false ?
                <div>
                    <Grid >
                        <Grid.Row >
                            <Grid.Column>   
                                <Header as='h3'>{tituloContenido}</Header>
                            </Grid.Column>
                    </Grid.Row> 
                    <Grid.Row>
                            <Grid.Column>
                                <Button onClick={regresar} color='instagram' fluid size='large'>
                                    Regresar
                                </Button>
                    </Grid.Column>
                    </Grid.Row>
                    <Grid.Row >
                            <Grid.Column textAlign="center" >
                                <div style={{"height": "45em"}} id="videoElementID">
                                    <ReactPlayerSin url={urlContenido}
                                        onDuration={onDuration}
                                        onProgress={(progress) => {videoProgreso(progress)}}
                                        onEnded={videoTerminado}

                                        onSeek={e => console.log('onSeek', e)}
                                        width='100%'
                                        controls={true}

                                         config={{ file: { 
                                            attributes: {
                                              controlsList: 'nodownload'
                                            }
                                          }}}

                                        playing={true}

                                        />

                                </div>
                             </Grid.Column>
                    </Grid.Row>
                    </Grid>
                </div>
            :
                ""
            }
        
        
        {idTipoContenido==29 &&visible==false ?
            <div>
            
            <Grid >
                    <Grid.Row >
                        <Grid.Column>   
                            <Header as='h3'>{tituloContenido}</Header>
                        </Grid.Column>
                </Grid.Row> 
                <Grid.Row>
                        <Grid.Column>
                            <Button onClick={regresar} color='instagram' fluid size='large'>
                                Regresar
                            </Button>
                </Grid.Column>
                </Grid.Row>
                <Grid.Row >
                        <Grid.Column textAlign="center" >
                           
                            <div >
                            
                                <Image src={urlContenido} size="huge"  centered />
                                
                                
                            </div>    
                            
                         </Grid.Column>
                </Grid.Row>
                                    
                                    
                </Grid>

            </div>
        :""}


        {idTipoContenido==32 &&visible==false ?
         <div>
            
            <Grid >
                    <Grid.Row >
                        <Grid.Column>   
                            <Header as='h3'>{tituloContenido}</Header>
                        </Grid.Column>
                </Grid.Row> 
                <Grid.Row>
                        <Grid.Column>
                            <Button onClick={regresar} color='instagram' fluid size='large'>
                                Regresar
                            </Button>
                </Grid.Column>
                </Grid.Row>
                <Grid.Row >
                        <Grid.Column textAlign="center" >
                           <Crossword data={dataCrucigrama} />
                         </Grid.Column>
                </Grid.Row>
                                    
                                    
                </Grid>

            </div>
        :""}    
        
        
        {idTipoContenido==28 &&visible==false ?
            
            <div>
                <Button onClick={regresar} color='instagram' fluid size='large'>Regresar</Button>

            {errorExamen==true?
                <Segment>
               <Message color='red'
                      icon='info circle'
                header='Aviso'
                content='Tuvimos un problema al guardar el resultado de su examen favor de dar click en el siguiente boton a fin de volver a enviar su resultado.'
                 />
                <Button onClick={saveExamen} color='orange' fluid size='large'>Guardar resultado</Button>
                </Segment>
            :
               ""
            }

            {errorExamen==false?
                <Segment>
               <Message color='green'
                      icon='info circle'
                header='Aviso'
                content='Tu resultado fue registrado correctamente.'
                 />
                </Segment>
            :
               ""
            }

        
            {quiz.id>0?
                <Segment style={{width: '100%', height:'80%'}}>
                    <Quiz quiz={quiz} showInstantFeedback={true} onComplete={setQuizResult} showDefaultResult={false} customResultPage={renderCustomResultPage} shuffle={true}/>
                 </Segment>
            :
                ""
            }


            {quiz.id==0 && quiz.numberOfQuestions!=null?

                  <Segment  style={{width: '100%', height:'80%'}}>
                        <Header as='h3'>{quiz.quizTitle}</Header>

                        Total de preguntas:{quiz.numberOfQuestions}<br/>
                        Correctas:{quiz.numberOfCorrectAnswers}<br/>
                        Incorrectas:{quiz.numberOfIncorrectAnswers}<br/>
                        Total de puntos posibles:{quiz.totalPoints}<br/>
                        Total obtenido:{quiz.correctPoints}<br/>



                    </Segment>    
    
                :

                    ""

            }
        
        </div>
        :""}
        
        
            </Segment>
            </Dimmer.Dimmable>
        

               <Button color='instagram' fluid size='large'  onClick={goBack}
										>{strings?strings["regresar"]:""}</Button>

        
      
        </div>
	);
};



export default CursoView;